import { render, staticRenderFns } from "./SelectTrackerFolder.vue?vue&type=template&id=4c58bd1b&"
import script from "./SelectTrackerFolder.vue?vue&type=script&lang=js&"
export * from "./SelectTrackerFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports